<template>
  <div class="v-keyboard" @click.stop="showKeyboard">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      type: {
        type: String// 1: 长密；2: 短密；3: 短信验证码
      },
      phone: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        keyboardInstance: null
      };
    },
    computed: {
      one() {
        return {
          "keyboardType": "1", // string 键盘类型:全键盘（支付长密码） [必须] 无默认值
          "title": "输入支付密码", // string标题 [非必须] 默认值:验证支付密码
          "subTitle": "", // string子标题 [非必须] 默认:输入网银钱包支付密码
          "inputPlaceHolder": "支付密码", // string placehodler [非必须] 默认值:支付密码
          "forgetBtnText": "忘记密码?", // string忘记密码btn [非必须] 默认:忘记密码?
          "confirmBtnText": "确定", // string确定按钮文案 [非必须] 默认：完成
          "confirmBtnTextColor": "#888888" // string确定按钮颜色 [非必须] 默认：蓝色
        };
      },
      two() {
        return {
          "keyboardType": "2",        // string 键盘类型:支付短密码  [必须] 无默认值
          "title": "输入支付密码",  // string标题 [非必须] 默认值:验证支付密码
          "subTitle": "", // string子标题 [非必须] 默认值:输入6位支付密码
          "forgetBtnText": "忘记密码?",   // string忘记密码btn [非必须] 默认:忘记密码?
          "isConfirmBtn": "0",           // string是否有确定按钮  [非必须] 默认："1"：只能传"0"/"1"
          "confirmBtnText": "确定",       // string确定按钮文案 [非必须] 默认：完成
          "confirmBtnColor":"blue"
        };
      },
      five() {
        return {
          "keyboardType": "5",
          "title": "输入短信验证码",                        // string标题             [非必须] 默认:验证短信
//          "otherVirifyBtnText": "其他验证方式",// string 其他验证方式 与 onChooseOtherMethod 配合使用
          "subTitle": `验证码已发送至${this.phone}`,   // string子标题            [非必须] 默认:输入手机尾号XXXX接收的验证码
          "isConfirmBtn": "0",            // string是否有确定按钮               [非必须] 默认："1"：只能传"0"/"1"
          "forgetBtnText": "收不到验证码?", // string忘记密码btn eg：收不到验证码?  [非必须] 默认:收不到验证码?
          "isAutoSendVCode": "1",         // string是否自动倒计时                [非必须] 默认："1"：只能传"0"/"1"
          "verifyCodeSenconds": "60",     // string倒计时秒数                   [非必须] 默认："60"
          "isIos12Version": '1',          // string ios12系统                  [非必须] 默认："0"：只能传"0"/"1"
          "confirmBtnText":"确定",         // string确定按钮文案                 [非必须] 默认：完成
          "confirmBtnColor":"blue"       // string确定按钮颜色                 [非必须] 默认：blue（red/blue俩套主题）
        };
      }
    },
    methods: {
      showKeyboard() {
        if (!this.type) {
          return;
        }
        
        if (this.type === '1') {
          this.showLongPass();
        } else if (this.type === '2') {
          this.showShortPass();
        } else if (this.type === '3') {
          this.showPhoneMessageCode();
        }
      },
      clearKeyboard() {
        let _this = this;
        _this.keyboardInstance.stopLoading();
        _this.keyboardInstance.clearAllInputContent();
      },
      destoryKeyboard() {
        let _this = this;
        _this.keyboardInstance.stopLoading();
        _this.keyboardInstance.close();
      },
      showPhoneMessageCode() {
        let logTitle = '--六位短信验证码---';
        let _this = this;
        console.log(logTitle);
        
        this.keyboardInstance.show({
          hasLoading:true,
          keyboards: [
            {
              keyboardParam: this.five,
              keyboardCertEnv: window.CONFIG.keyboardCertEnv,
//              onChooseOtherMethod: function () {
//              },
              onForgetPassword: function () {
              },
              onReceiveCodeFailed: function () {
                console.log(logTitle + 'onReceiveCodeFailed');
                _this.$emit('receive-code-failed');
              },
              onResentCode: function () {
                console.log(logTitle + 'onResentCode');
                _this.$emit('resent-code');
              },
              onConfirm: function (value, cryptStr) {
                console.log(logTitle + `confirm: ${value} cryptStr: ${cryptStr}`);
                _this.$emit('confirm', value);
              },
              onShow: function () {
                console.log(logTitle + 'onShow');
              },
              onClosed: function () {
                console.log(logTitle + 'onClosed');
              }
            },
          ]
        });
      },
      showShortPass() {
        let logTitle = '--六位支付密码 不加确定按钮---';
        let _this = this;
        console.log(logTitle);
        this.keyboardInstance.show({
          hasLoading:true,
          keyboards: [
            {
              keyboardInputId: 'shortPass',
              keyboardParam: this.two,
              keyboardCertEnv: window.CONFIG.keyboardCertEnv,
              onForgetPassword: function () {
                console.log('forget short password');
                _this.$emit('forget-password');
              },
              onConfirm: function (value, cryptStr) {
                console.log(logTitle + `confirm: ${value} cryptStr: ${cryptStr}`);
                _this.$emit('confirm', cryptStr);
              },
              onShow: function () {
                console.log(logTitle + 'onShow');
              },
              onClosed: function () {
                console.log(logTitle + 'onClosed');
              }
            },
          ]
        });
      },
      showLongPass() {
        let logTitle = '--非六位支付密码 加确定按钮---';
        let _this = this;
        console.log(logTitle);
        this.keyboardInstance.show({
          hasLoading:true,
          keyboards: [
            {
              keyboardInputId: 'longPass',
              keyboardParam: this.one,
              keyboardCertEnv: window.CONFIG.keyboardCertEnv,
              onForgetPassword: function () {
                console.log('forget long password');
                _this.$emit('forget-password');
              },
              onConfirm: function (value, cryptStr) {
                console.log(logTitle + `confirm: ${value} cryptStr: ${cryptStr}`);
                _this.$emit('confirm', cryptStr);
              },
              onShow: function () {
                console.log(logTitle + 'onShow');
              },
              onClosed: function () {
                console.log(logTitle + 'onClosed');
              }
            },
          ]
        });
      }
    },
    mounted() {
      this.keyboardInstance = KeyboardManager.getInstance();
      
      this.$on('show', this.showKeyboard);
      this.$on('clear', this.clearKeyboard);
      this.$on('destroy', this.destoryKeyboard);
    },
    beforeDestroy() {
      this.destoryKeyboard();
    }
  };
</script>